// extracted by mini-css-extract-plugin
module.exports = {"ContactPhone":"index-module_ContactPhone_2t1C8"};